export default function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/order/none.js
// module id = 35
// module chunks = 0 1 2 3 4